import React, { useState, useEffect } from 'react';
import HeaderComponent from '../components/General/HeaderComponent';
import StickyNotesComponent from '../components/Panel/StickyNotesComponent';

export default function Tasks() {
  const [projectId, setProjectId] = useState(null);

  useEffect(() => {
    // LocalStorage'dan veya başka bir yerden projectId'yi al
    // Şimdilik varsayılan bir değer kullanıyoruz
    const defaultProjectId = 'nacs-60383'; // Bu değeri dinamik hale getirebiliriz
    setProjectId(defaultProjectId);
  }, []);

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Notlar" />
        <StickyNotesComponent projectId={projectId} />
      </div>
    </div>
  );
}
